import CookiePolicy from '@resources/js/components/cookie-policy/CookiePolicy';
import initHotjar from '@resources/js/components/initHotjar';
if (CookiePolicy.hasAllowedOptional())
    initHotjar();
CookiePolicy.on('optional-allowed', initHotjar);
